import { SyncUser } from './Auth';

export enum ServiceAccountAccess {
  LIMITED = 'limited',
  FULL = 'full',
}

export enum AccountStatus {
  ACTIVATED = 'activated',
  DEACTIVATED = 'deactivated',
}

export interface ServiceAccount extends SyncUser {
  restricted: boolean;
  autoAssign: boolean;
  activeTicketCount?: number;
  notes?: string;
}
